// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Efud","comment":"styles_comment__1zpW2"};